import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";
import { useEffect } from "react";

const utils = createTrackingUtils({
  name: "flights_web_move_branded_fares_cta_mdot",
  stages: {
    inViewport: 2,
    direct: 3,
    meta: 4,
    families: 5,
    longHaul: 6,
    weekendTravellers: 7
  },
  goals: {
    bfCtaClick: 1
  },
  defaultStage: 1
});

const useTrackStages = (isEligible?: boolean, isInViewport?: boolean) => {
  const { stages } = utils;
  const { isDirect, isMeta, isFamily, isLongHaul, isWeekendStay } = useProfiler();

  useEffect(() => {
    if (!isEligible) {
      return;
    }

    isInViewport && stages.inViewport();
    isDirect() && stages.direct();
    isMeta() && stages.meta();
    isFamily() && stages.families();
    isLongHaul() && stages.longHaul();
    isWeekendStay() && stages.weekendTravellers();
  }, [stages, isDirect, isMeta, isEligible, isFamily, isLongHaul, isWeekendStay, isInViewport]);
};

export default { ...utils, useTrackStages };
